import { useMemo } from 'react';

import { ScheduledApp } from '@crossnokaye/typescript-sdk/models/components';

import { DesktopTopNav } from '@/components/navigation/top/components/desktop-top-nav';
import { MobileTopNav } from '@/components/navigation/top/components/mobile-top-nav';
import { removeEnvironmentFromFacilityName } from '@/components/navigation/utils';
import { ScheduledAppKind } from '@/constants/scheduled-apps';
import { useScheduledApps } from '@/hooks/query-hooks/scheduling';
import { useCurrentFacility } from '@/hooks/use-current-facility';
import {
  DeviceTypeDetectionVariant,
  useDeviceTypeDetection,
} from '@/ux-common/hooks/use-device-type-detection/use-device-type-detection';

export const TopNavigation = () => {
  const { isMobile } = useDeviceTypeDetection({
    variant: DeviceTypeDetectionVariant.DeviceOnly,
  });

  const {
    orgName: organizationName,
    currentFacility,
    organizationId: orgId,
    agentId,
  } = useCurrentFacility();

  const { data: scheduledApps } = useScheduledApps({
    orgId,
    agentId,
    kind: ScheduledAppKind.ThermalLoadShifting,
  });

  const isSheddingActive = useMemo(() => {
    const isAppShedding = (app: ScheduledApp) => {
      return app.status?.outputs?.shedding_active === 'true';
    };
    return scheduledApps?.some(isAppShedding) ?? false;
  }, [scheduledApps]);

  const { orgName, facilityName } = useMemo(
    () => ({
      orgName: organizationName ?? '',
      facilityName: currentFacility?.displayName
        ? removeEnvironmentFromFacilityName(currentFacility.displayName)
        : '',
    }),
    [organizationName, currentFacility]
  );

  const TopNavComponent = isMobile ? MobileTopNav : DesktopTopNav;

  return (
    <TopNavComponent
      {...{
        orgName,
        facilityName,
        showEaiBadge: isSheddingActive,
      }}
    />
  );
};
